import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: String(process.env.REACT_APP_FIREBASE_API_KEY ?? ""),
  authDomain: String(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? ""),
  projectId: String(process.env.REACT_APP_FIREBASE_PROJECT_ID ?? ""),
  storageBucket: String(process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? ""),
  messagingSenderId: String(
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? ""
  ),
  appId: String(process.env.REACT_APP_FIREBASE_APP_ID ?? ""),
  measurementId: String(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ?? ""),
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
/**
 * Xin quyền và lấy FCM token
 */
export const requestPermission = async () => {
  try {
    if (typeof Notification === "undefined") {
      return null;
    }

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.warn("User denied notifications permission");
      return null;
    }

    // Lấy token
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_WEB_PUSH_CERTIFICATE_KEY_PAIR ?? "",
    });

    if (token) {
      return token;
    } else {
      console.warn("Can't get fcm token (null). Check VAPID key.");
      return null;
    }
  } catch (error) {
    console.error("Can't get fcm token:", error);
    return null;
  }
};

/**
 * Nhận notification khi tab đang mở (foreground)
 */
export const listenNotification = () => {
  onMessage(messaging, (payload) => {
    if (Notification.permission === "granted") {
      const { title, body, image } = payload.notification ?? {};

      new Notification(title ?? "Notifications", {
        body,
        icon: image || "/firebase-logo.png", // có thể dùng icon từ payload
      });
    } else {
      console.warn("User has not granted Notification permission !");
    }
  });
};

